import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: 'app-renting-house',
  templateUrl: './renting-house.component.html',
  styleUrls: ['./renting-house.component.scss']
})
export class RentingHouseComponent implements OnInit {

   public deeplink;

  constructor(public route:ActivatedRoute, public sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      let id = params['id']
      if(id!==undefined){
        this.deeplink = this.sanitizer.bypassSecurityTrustResourceUrl("https://playdex.io/games/kryptomon/assets/"+id)
      }else{
        this.deeplink = this.sanitizer.bypassSecurityTrustResourceUrl("https://playdex.io/games/kryptomon?mode=presentation")
      }
    })
  }

}
